import http from "../../../utils/fetch";

export default {
    baseurl:'/api/swyl/v1/agent/bscAgentWeekMeeting',

    selecPage(query) {
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    selectById(id){
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            params: {id:id}
        });
    },

//查询经销商拥有的所有渠道
    selectChannel(agentCode) {
        return http({
            url: this.baseurl+'/selectChannel',
            method: 'post',
            params: {agentCode}
        });
    },
    insert(f){
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            data: f
        });
    },
    updateById(f){
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            data: f
        });
    },

    //获取经销商月目标信息
    getMonthTarget(agentCode) {
        return http({
            url: this.baseurl+'/getMonthTarget',
            method: 'post',
            params: {agentCode}
        });
    },

    tzGrade(query) {
        return http({
            url: this.baseurl+'/tzGrade',
            method: 'post',
            data: query
        });
    },

    selectMeetingReport(query) {
        return http({
            url: this.baseurl+'/selectMeetingReportPage',
            method: 'post',
            params: query
        });
    },

    selectMeetingReportFile(query) {
        return http({
            url: this.baseurl+'/selectMeetingReportFile',
            method: 'post',
            params: query
        });
    },



}
